import { Component, Input } from "@angular/core";

@Component({
  selector: "app-error-message",
  standalone: false,
  template: `
    <div class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
    </div>
  `,
  styles: [
    `
      .error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        text-align: center;
      }
      mat-icon {
        font-size: 48px;
        width: 48px;
        height: 48px;
      }
      h3 {
        margin: 16px 0 8px;
      }
      p {
        color: rgba(0, 0, 0, 0.54);
        margin: 0;
      }
    `,
  ],
})
export class ErrorMessageComponent {
  @Input() title = "Error";
  @Input() message = "An error occurred while loading data.";
}
